module.exports = __webpack_public_path__ + "img/prioritas_bosspack_dfod_dg_k.68d3815a.png";